import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Field, SubmitButton } from "@/components/site/FormBits";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) return setError("Passwords do not match");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20" data-testid="reset-password-page">
      <p className="eyebrow">Account</p>
      <h1 className="mt-4 font-display text-4xl tracking-tight">Choose a new password</h1>
      {done ? (
        <div data-testid="reset-success" className="mt-8 bg-white border border-[#E4E1D9] p-6 text-sm text-[#57534E]">
          Your password has been updated.
          <Link to="/auth" data-testid="reset-goto-signin" className="mt-4 flex items-center justify-center h-12 bg-[#121417] text-white hover:bg-[#9F7E44]">Sign in</Link>
        </div>
      ) : !token ? (
        <p data-testid="reset-missing-token" className="mt-8 text-sm text-[#57534E]">
          This link is incomplete. <Link to="/forgot-password" className="text-[#9F7E44]">Request a new reset link</Link>.
        </p>
      ) : (
        <form onSubmit={submit} className="mt-8 space-y-5">
          <Field label="New password" required hint="At least 8 characters">
            <input data-testid="reset-input-password" type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} className="field-input" />
          </Field>
          <Field label="Confirm new password" required>
            <input data-testid="reset-input-confirm" type="password" required minLength={8} value={confirm} onChange={(e) => setConfirm(e.target.value)} className="field-input" />
          </Field>
          {error && (
            <p data-testid="reset-error" className="text-sm text-red-700 bg-red-50 border border-red-200 px-3 py-2">
              {error} {error.includes("expired") && <Link to="/forgot-password" className="underline">Request a new link</Link>}
            </p>
          )}
          <SubmitButton loading={loading} testId="reset-submit-btn" className="w-full">Update password</SubmitButton>
        </form>
      )}
    </div>
  );
}
